/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.rpc.ViewsCrudRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type DefaultTaskStatusOption =
  | 'COMPLETED'
  | 'DEFERRED'
  | 'IN_PROGRESS'
  | 'NOT_STARTED'
  | 'WAITING'
  | unhandledEnumCase;

export type Direction = 'FORWARD' | 'BACKWARD' | unhandledEnumCase;

export type FilterDateTimeFormat =
  | 'EPOCH_MILLISECONDS'
  | 'DATE'
  | 'RELATIVE_TIME_DURATION'
  | unhandledEnumCase;

export type FilterOperator =
  | 'EQ'
  | 'NEQ'
  | 'LT'
  | 'LTE'
  | 'GT'
  | 'GTE'
  | 'BETWEEN'
  | 'IN'
  | 'NOT_IN'
  | 'HAS_PROPERTY'
  | 'NOT_HAS_PROPERTY'
  | 'ROLLING_DATE_RANGE'
  | 'TIME_UNIT_TO_DATE'
  | 'BEFORE_ROLLING_DATE_POINT'
  | 'AFTER_ROLLING_DATE_POINT'
  | 'LT_X_DAYS'
  | 'GT_X_DAYS'
  | 'CONTAINS_ALL'
  | 'DOES_NOT_CONTAIN_ALL'
  | 'IS_EXACTLY'
  | 'IS_NOT_EXACTLY'
  | 'EQ_PROPERTY'
  | 'NEQ_PROPERTY'
  | 'LT_PROPERTY'
  | 'LTE_PROPERTY'
  | 'GT_PROPERTY'
  | 'GTE_PROPERTY'
  | unhandledEnumCase;

export type FilterTimeUnit =
  | 'SECOND'
  | 'MINUTE'
  | 'HOUR'
  | 'DAY'
  | 'WEEK'
  | 'MONTH'
  | 'QUARTER'
  | 'YEAR'
  | unhandledEnumCase;

export type MetricType =
  | 'SUM'
  | 'AVG'
  | 'MIN'
  | 'MAX'
  | 'DISTINCT_APPROX'
  | 'PERCENTILES'
  | 'COUNT'
  | unhandledEnumCase;

export namespace ComHubspotCrmSearchCore {
  export type SortOrder = 'ASC' | 'DESC' | unhandledEnumCase;
}

export type VisualizationSettingsError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ErrorType =
  | 'INPUT_TOO_LONG'
  | 'INVALID_REQUEST'
  | 'VISUALIZATION_SETTINGS_NOT_FOUND'
  | 'USER_NOT_AUTHORIZED'
  | 'DEFAULT_VISUALIZATION_SETTINGS_NOT_FOUND'
  | 'OBJECT_NOT_FOUND'
  | 'INTERNAL_ERROR'
  | 'DUPLICATE_SETTINGS_ENTRY'
  | 'DUPLICATE_USER_VIEW_SETTINGS_ENTRY'
  | 'DUPLICATE_USER_VISUALIZATION_TYPE_SETTINGS_ENTRY'
  | 'INVALID_TASK_STATUSES'
  | 'INVALID_TIME_UNIT'
  | 'INVALID_DAY_WIDTH'
  | 'BATCH_REQUEST_TOO_LARGE'
  | 'INVALID_PROPERTY_NAMES'
  | 'INVALID_FROZEN_COLUMNS'
  | 'INVALID_COLUMN_NAMES'
  | 'INVALID_NAME_COLUMN_NAME'
  | 'INVALID_REPORT_ID'
  | 'UNSUPPORTED_AUDIENCE_TYPE'
  | 'SETTINGS_TYPE_MISMATCH'
  | 'OBJECT_TYPE_ID_REQUIRED'
  | 'INVALID_DEFAULT_VIEW_TARGET'
  | unhandledEnumCase;

export type AudienceType = 'USER' | 'PORTAL' | unhandledEnumCase;

export type DisplayOtherItemKey =
  | 'DURATION'
  | 'OPEN_SINCE'
  | 'FULL_NAME'
  | unhandledEnumCase;

export type GradientType =
  | 'BLUE_TO_WHITE'
  | 'GREEN_TO_WHITE'
  | 'YELLOW_TO_WHITE'
  | 'ORANGE_TO_WHITE'
  | 'PURPLE_TO_WHITE'
  | 'GREEN_TO_YELLOW_TO_RED'
  | 'RED_TO_YELLOW_TO_GREEN'
  | 'GREEN_TO_WHITE_TO_RED'
  | 'RED_TO_WHITE_TO_GREEN'
  | unhandledEnumCase;

export type TargetType =
  | 'VIEW'
  | 'VISUALIZATION_TYPE'
  | 'DEFAULT_VIEW'
  | unhandledEnumCase;

export type TimeUnit =
  | 'DAYS'
  | 'WEEKS'
  | 'MONTHS'
  | 'QUARTERS'
  | 'YEARS'
  | unhandledEnumCase;

export type VisualizationType =
  | 'GANTT_CHART'
  | 'BOARD'
  | 'TABLE'
  | 'REPORT'
  | 'CALENDAR'
  | 'MAP'
  | unhandledEnumCase;

export type SettingsResponse = {
  id: number;
  portalId: number;
  visualizationType: VisualizationType;
  audienceType: AudienceType;
  audience: string;
  targetType: TargetType;
  target: string;
  settings: Settings;
  createdBy?: number;
  updatedBy?: number;
  createdAt: number;
  updatedAt: number;
  /** @deprecated */
  viewId: Default<number>;
};

export type SettingsUpsertResult = {
  response?: SettingsResponse;
  error?: VisualizationSettingsError;
};

export const BoardSettingsTypename =
  'com.hubspot.crm.visualization.settings.models.settings.BoardSettings';
export const BoardSettingsDiscriminant = 'Board Settings';
export const BoardSettingsDiscriminantKey = '@type';
export type BoardSettings = {
  boardProperty: string;
  columnPropertyValues: Default<string[]>;
  laneInsights?: LaneInsights;
  showNoValueLane?: boolean;
  sortType?: string;
  __typename: 'com.hubspot.crm.visualization.settings.models.settings.BoardSettings';
} & { '@type'?: 'Board Settings' };

export const CalendarSettingsTypename =
  'com.hubspot.crm.visualization.settings.models.settings.CalendarSettings';
export const CalendarSettingsDiscriminant = 'Calendar Settings';
export const CalendarSettingsDiscriminantKey = '@type';
export type CalendarSettings = {
  dateProperties: DateProperties;
  showWeekends: boolean;
  showAllDayEvents: boolean;
  displayProperties?: DisplayCardSettings;
  showStartTime: Default<boolean>;
  __typename: 'com.hubspot.crm.visualization.settings.models.settings.CalendarSettings';
} & { '@type'?: 'Calendar Settings' };

export const GanttChartSettingsTypename =
  'com.hubspot.crm.visualization.settings.models.settings.GanttChartSettings';
export const GanttChartSettingsDiscriminant = 'Gantt Chart Settings';
export const GanttChartSettingsDiscriminantKey = '@type';
export type GanttChartSettings = {
  dateProperties?: DateProperties;
  timeUnit?: TimeUnit;
  dayWidth?: number;
  /** @deprecated */
  taskStatuses: Default<DefaultTaskStatusOption[]>;
  taskStageIds: Default<string[]>;
  columns: Default<Column[]>;
  displayPropertyConfig?: DisplayPropertyConfig;
  tableWidth: Default<number>;
  __typename: 'com.hubspot.crm.visualization.settings.models.settings.GanttChartSettings';
} & { '@type'?: 'Gantt Chart Settings' };

export const MapSettingsTypename =
  'com.hubspot.crm.visualization.settings.models.settings.MapSettings';
export const MapSettingsDiscriminant = 'Map Settings';
export const MapSettingsDiscriminantKey = '@type';
export type MapSettings = {
  __typename: 'com.hubspot.crm.visualization.settings.models.settings.MapSettings';
} & { '@type'?: 'Map Settings' };

export const ReportSettingsTypename =
  'com.hubspot.crm.visualization.settings.models.settings.ReportSettings';
export const ReportSettingsDiscriminant = 'Report Settings';
export const ReportSettingsDiscriminantKey = '@type';
export type ReportSettings = {
  reportId?: number;
  __typename: 'com.hubspot.crm.visualization.settings.models.settings.ReportSettings';
} & { '@type'?: 'Report Settings' };

export const SettingsDiscriminantKey = '@type';
export type Settings =
  | GanttChartSettings
  | BoardSettings
  | TableSettings
  | ReportSettings
  | CalendarSettings
  | MapSettings;

export const TableSettingsTypename =
  'com.hubspot.crm.visualization.settings.models.settings.TableSettings';
export const TableSettingsDiscriminant = 'Table Settings';
export const TableSettingsDiscriminantKey = '@type';
export type TableSettings = {
  columns: Default<Column[]>;
  numberOfFrozenColumns: number;
  conditionalHighlightRules: Default<ConditionalHighlightRule[]>;
  inlineAssociationTableStates: Default<
    Record<string, InlineAssociationTableState>
  >;
  activeInlineAssociationObjectTypeId?: string;
  __typename: 'com.hubspot.crm.visualization.settings.models.settings.TableSettings';
} & { '@type'?: 'Table Settings' };

export type AggregationData = {
  property?: string;
  aggregation?: MetricType;
  mandatory: Default<boolean>;
  meta?: AggregationMetadata;
  defaultSettingId?: string;
};

export type AggregationMetadata = {
  currencyProperty?: string;
  weighted: Default<boolean>;
  projected: Default<boolean>;
};

export type BoardLocation = 'HEADER' | 'FOOTER' | unhandledEnumCase;

export type LaneInsights = {
  summaryPlacement: BoardLocation;
  aggregations: Default<AggregationData[]>;
  metricAggregations: Default<MetricAggregation[]>;
};

export type MetricAggregation = { metricName: string };

export type DateProperties = {
  startDatePropertyName: string;
  endDatePropertyName?: string;
};

export type DisplayCardSettings = {
  items: Default<DisplayItemIF[]>;
  objectTypeId: string;
};

export const DisplayItemIFDiscriminantKey = 'type';
export type DisplayItemIF = DisplayPropertyItem | DisplayOtherItem;

export const DisplayOtherItemTypename =
  'com.hubspot.crm.visualization.settings.models.settings.display.models.DisplayOtherItem';
export const DisplayOtherItemDiscriminant = 'OTHER';
export const DisplayOtherItemDiscriminantKey = 'type';
export type DisplayOtherItem = {
  key: DisplayOtherItemKey;
  order: number;
  __typename: 'com.hubspot.crm.visualization.settings.models.settings.display.models.DisplayOtherItem';
} & { type?: 'OTHER' };

export type DisplayPropertyConfig = {
  parentObjectSettings: DisplayCardSettings;
  childObjectSettings: DisplayCardSettings;
};

export const DisplayPropertyItemTypename =
  'com.hubspot.crm.visualization.settings.models.settings.display.models.DisplayPropertyItem';
export const DisplayPropertyItemDiscriminant = 'PROPERTY';
export const DisplayPropertyItemDiscriminantKey = 'type';
export type DisplayPropertyItem = {
  name: string;
  order: number;
  __typename: 'com.hubspot.crm.visualization.settings.models.settings.display.models.DisplayPropertyItem';
} & { type?: 'PROPERTY' };

export type AssociationFilter = {
  property: string;
  operator: FilterOperator;
  value?: string;
  highValue?: string;
  values: Default<string[]>;
  comparisonProperty?: string;
  dateTimeFormat?: FilterDateTimeFormat;
  timeUnit?: FilterTimeUnit;
  timeUnitCount?: number;
  rollingOffsetUnit?: FilterTimeUnit;
  rollingOffset?: number;
  rollForward?: boolean;
  direction?: Direction;
  inclusive?: boolean;
  upperBoundInclusive?: boolean;
  lowerBoundInclusive?: boolean;
  propertySuffix?: string;
};

export type AssociationFilterGroup = { filters: Default<AssociationFilter[]> };

export type AssociationSort = {
  property: string;
  order: ComHubspotCrmSearchCore.SortOrder;
};

export type Column = {
  propertyName: string;
  width?: number;
  objectTypeId?: string;
};

export const ConditionalHighlightRuleDiscriminantKey = '@type';
export type ConditionalHighlightRule = GradientRule;

export type InlineAssociationTableState = {
  filterGroups: Default<AssociationFilterGroup[]>;
  quickFilterPropertyNames: Default<string[]>;
  columns: Default<Column[]>;
  sorts: Default<AssociationSort[]>;
  conditionalHighlightRules: Default<ConditionalHighlightRule[]>;
};

export const GradientRuleTypename =
  'com.hubspot.crm.visualization.settings.models.settings.table.models.highlight.rules.GradientRule';
export const GradientRuleDiscriminant = 'Gradient Rule';
export const GradientRuleDiscriminantKey = '@type';
export type GradientRule = {
  gradientType: GradientType;
  columnName: string;
  __typename: 'com.hubspot.crm.visualization.settings.models.settings.table.models.highlight.rules.GradientRule';
} & { '@type'?: 'Gradient Rule' };

export type CollectionType =
  | 'unknown'
  | 'companies'
  | 'contacts'
  | 'deals'
  | 'prospects'
  | 'visits'
  | 'news'
  | 'tasks'
  | 'tickets'
  | unhandledEnumCase;

export type SalesView = {
  id: Default<number>;
  ownerId: Default<number>;
  portalId: Default<number>;
  name?: string;
  state?: string;
  columns?: string;
  filters?: string;
  collectionType?: CollectionType;
  private: Default<boolean>;
  type?: ViewType;
  teamId: Default<number>;
  objectTypeId?: string;
  idLabel?: string;
  filterGroups?: string;
  quickFilters?: string;
  namespace: Default<number>;
  createdBy: Default<number>;
  lastModifiedBy: Default<number>;
  createdTimestamp: Default<number>;
  lastModifiedTimestamp: Default<number>;
  legacyCompatible: Default<boolean>;
  permissionUserIds: Default<number[]>;
  namespaceName?: string;
  quickFilterProperties?: string;
  viewColor?: string;
  currentViewVisualization?: string;
  activeVisualizationType?: string;
  visualizationSettingsString?: string;
  description?: string;
  workspaceId: Default<number>;
  crossObjectFilterObjectType?: string;
  viewVersion: Default<number>;
  lastUsedTimestamp: Default<number>;
  lastUsedUserId: Default<number>;
  publicDefaultRole: Default<number>;
  colorBy?: string;
};

export type ViewType =
  | 'STANDARD'
  | 'QUEUE'
  | 'FORECAST'
  | 'DEFAULT'
  | unhandledEnumCase;

export type BulkDeleteFailureReason =
  | 'NOT_FOUND'
  | 'ALREADY_DELETED'
  | 'NOT_OWNER'
  | 'INVALID_ID'
  | unhandledEnumCase;

export type BulkDeleteViewsRequest = { viewIds: Default<number[]> };

export type BulkDeleteViewsResponse = {
  deletedViewIds: Default<number[]>;
  failures: Default<BulkOperationViewFailure[]>;
};

export type BulkOperationViewFailure = {
  viewId: number;
  reason: string;
  reasonCode?: BulkDeleteFailureReason;
};

export type BulkTransferViewOwnershipRequest = {
  viewIds: Default<number[]>;
  newOwnerId: number;
  retainOldOwnerAsCollaborator: Default<boolean>;
};

export type BulkTransferViewOwnershipResponse = {
  transferredViewIds: Default<number[]>;
  failures: Default<BulkOperationViewFailure[]>;
};

export type ComposableSearchRequest = {
  composableSearch: ComposableSearch;
  limit: Default<number>;
  pagingToken?: string;
  includeLastUsed: Default<boolean>;
};

export type ComposableSearchResponse = {
  results: Default<ViewWithPermissions[]>;
  total: number;
  hasMore: boolean;
  offset: string;
};

export type CreateViewRequest = {
  view: ViewCreateInput;
  namespace?: number;
  clonedFromViewIdOrName?: string;
};

export type CreateViewWithVisualizationSettingsAndPermissionsRequest = {
  view: ViewCreateInput;
  namespace?: number;
  clonedFromViewIdOrName?: string;
  visualizationSettingsMap: Default<
    Record<string, PortalViewSettingsUpsertRequest>
  >;
  viewPermissions?: ViewPermissionInput[];
};

export type CreateViewWithVisualizationSettingsAndPermissionsResponse = {
  status: ViewWithVisualizationSettingsMapUpsertResponseStatus;
  persistedView?: SalesView;
  visualizationSettingsMap: Default<Record<string, SettingsUpsertResult>>;
  errorMessage?: string;
  userRole?: ViewRole;
};

export type DeletedViewResult = {
  view: SalesView;
  deletedBy: number;
  deletedAt: number;
};

export type GetDeletedViewsRequest = {
  namespace: Namespace;
  objectTypeIds: Default<string[]>;
  viewName?: string;
  sortColumn?: string;
  sortOrder?: ComHubspotSalesModelsViews.SortOrder;
  limit: Default<number>;
  pagingToken?: string;
};

export type GetDeletedViewsResponse = {
  results: Default<DeletedViewResult[]>;
  total: number;
  hasMore: boolean;
  offset: string;
};

export type GetViewRequest = {
  viewIdOrName: string;
  objectTypeId: string;
  namespace?: number;
  skipPersonalization: Default<boolean>;
};

export type MultiTransferViewOwnershipRequest = {
  assignments: Default<ViewOwnerAssignment[]>;
  retainOldOwnerAsCollaborator: Default<boolean>;
};

export type MultiTransferViewOwnershipResponse = {
  transferredViewIds: Default<number[]>;
  failures: Default<BulkOperationViewFailure[]>;
};

export type RestoreViewFailure = {
  viewId: number;
  reason: RestoreViewFailureReason;
};

export type RestoreViewFailureReason =
  | 'NOT_FOUND'
  | 'PERMISSION_DENIED'
  | 'ALREADY_ACTIVE'
  | unhandledEnumCase;

export type RestoreViewsRequest = { viewIds: Default<number[]> };

export type RestoreViewsResponse = {
  restoredViewIds: Default<number[]>;
  failures: Default<RestoreViewFailure[]>;
};

export type UpdateContractSettingsRequest = {
  viewId: number;
  objectTypeId: string;
  namespace?: number;
  name?: string;
  state?: string;
};

export type UpdateViewRequest = { viewIdString: string; view: ViewUpdateInput };

export type ViewCreateInput = {
  name: string;
  columns: string;
  private: boolean;
  objectTypeId: string;
  ownerId?: number;
  collectionType?: CollectionType;
  type?: ViewType;
  description?: string;
  filterGroups?: string;
  quickFilters?: string;
  quickFilterProperties?: string;
  viewColor?: string;
  state?: string;
  idLabel?: string;
  workspaceId?: number;
  crossObjectFilterObjectType?: string;
  currentViewVisualization?: string;
  colorBy?: string;
  activeVisualizationType?: string;
  visualizationSettingsString?: string;
  publicDefaultRole?: number;
  permissionUserIds: Default<number[]>;
  permissionTeamIds: Default<number[]>;
};

export type ViewOwnerAssignment = { viewId: number; newOwnerUserId: number };

export type ViewPermissionInput = {
  principalId: number;
  principalType: ViewPrincipalType;
  viewRole: ViewRole;
};

export type ViewUpdateInput = {
  ownerId: number;
  name: string;
  columns: string;
  private: boolean;
  objectTypeId: string;
  collectionType?: CollectionType;
  type?: ViewType;
  description?: string;
  filterGroups?: string;
  quickFilters?: string;
  quickFilterProperties?: string;
  viewColor?: string;
  state?: string;
  idLabel?: string;
  workspaceId?: number;
  crossObjectFilterObjectType?: string;
  currentViewVisualization?: string;
  colorBy?: string;
  activeVisualizationType?: string;
  visualizationSettingsString?: string;
  publicDefaultRole?: number;
  permissionTeamIds?: number[];
  permissionUserIds?: number[];
};

export type ViewWithPermissions = {
  view: SalesView;
  permissions: Default<ViewPermission[]>;
  userRole?: ViewRole;
};

export type ViewWithUserRole = {
  view: SalesView;
  permissionTeamIds: Default<number[]>;
  userRole?: ViewRole;
};

export type ViewsRpcError = {
  errorType: ViewsRpcErrorType;
  errorMessage: string;
  statusCode?: number;
  propertyNames: Default<string[]>;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ViewsRpcErrorType =
  | 'BOARD_CONFIG_COPY_FAILED'
  | 'CRM_SEARCH_ERROR'
  | 'CROSS_OBJECT_FILTERS_NOT_SUPPORTED'
  | 'HIGHLY_SENSITIVE_PROPERTY'
  | 'IMPORT_LIST_NOT_FOUND'
  | 'INTERNAL_ERROR'
  | 'INVALID_COUNT'
  | 'INVALID_PROPERTY'
  | 'INVALID_REQUEST'
  | 'MAX_COUNT_EXCEEDED'
  | 'MISSING_PORTAL_IN_REQUEST'
  | 'MISSING_USER_IN_REQUEST'
  | 'PERMISSION_DENIED'
  | 'PERSONALIZED_VIEW_NOT_FOUND'
  | 'PROPERTY_PERMISSION_DENIED'
  | 'QUERY_TOO_LONG'
  | 'RATE_LIMITED'
  | 'SEARCH_TIMEOUT'
  | 'SORT_PROPERTY_TOO_LARGE'
  | 'VIEW_NOT_FOUND'
  | unhandledEnumCase;

export type ViewPermission = {
  portalId: number;
  objectTypeId: string;
  namespace: Namespace;
  principalId: number;
  principalType: ViewPrincipalType;
  viewId: number;
  viewRole: Default<ViewRole>;
};

export type ComposableSearch = {
  namespace?: Namespace;
  objectTypeIds: Default<string[]>;
  ownerIds: Default<number[]>;
  teamIds: Default<number[]>;
  private?: boolean;
  viewName?: string;
  lastUsedTimestampFrom?: number;
  lastUsedTimestampTo?: number;
  sortColumn: Default<string>;
  sortOrder: Default<ComHubspotSalesModelsViews.SortOrder>;
  exactNameSearch: Default<boolean>;
};

export type Namespace =
  | 'NONE'
  | 'TEST'
  | 'BLOG_POSTS'
  | 'LISTS'
  | 'TASKS'
  | 'LANDING_PAGES'
  | 'SITE_PAGES'
  | 'DEALS'
  | 'OBJECT_LISTS'
  | 'WORKFLOWS'
  | 'FORMS'
  | 'MARKETING_SMS'
  | 'MARKETING_EMAIL'
  | 'WEB_INTERACTIVES'
  | 'PRODUCT_APPROVALS'
  | 'SURVEYS'
  | 'CUSTOMER_SUCCESS'
  | 'KNOWLEDGE_ARTICLES'
  | 'AUTOMATION_JOURNEYS'
  | 'PODCAST_EPISODES'
  | 'CUSTOMER_SUCCESS_PIPELINE'
  | 'DATA_PRIVACY_REQUEST'
  | 'CMP_BLOG_POSTS'
  | 'CMP_LANDING_PAGES'
  | 'CMP_SITE_PAGES'
  | 'LEADS'
  | 'TARGET_ACCOUNTS'
  | 'CALENDAR'
  | 'SALES_WORKSPACE'
  | 'SEQUENCES'
  | 'TEMPLATES'
  | 'SNIPPETS'
  | 'WHATSAPP'
  | 'SEGMENTS'
  | 'ONBOARDING_AI_GENERATED'
  | 'PDM_WORKSPACE'
  | 'USERS'
  | 'STRATEGIC_PDM_WORKSPACE'
  | 'MARKET_SEGMENTS'
  | 'AUTOMATION_STUDIO'
  | unhandledEnumCase;

/**
 *  Portal-level view settings upsert request.
 *  Contains all the fields needed for upserting visualization settings at the portal level.
 */
export type PortalViewSettingsUpsertRequest = {
  id: number;
  visualizationType: VisualizationType;
  viewId: number;
  settings: Settings;
  objectTypeId: string;
  audienceType: Default<AudienceType>;
  targetType: Default<TargetType>;
  target?: string;
};

export type ViewPrincipalType = 'USER' | 'TEAM' | unhandledEnumCase;

export type ViewRole =
  | 'OWNER'
  | 'COLLABORATOR'
  | 'MEMBER'
  | 'NO_ACCESS'
  | unhandledEnumCase;

export type ViewWithVisualizationSettingsMapUpsertResponseStatus =
  | 'SUCCESS'
  | 'VIEW_NOT_SAVED_BAD_REQUEST'
  | 'VIEW_NOT_SAVED_INTERNAL_ERROR'
  | 'VISUALIZATION_SETTINGS_NOT_SAVED'
  | 'PERMISSIONS_NOT_SAVED'
  | 'BOARD_CONFIG_NOT_SAVED'
  | unhandledEnumCase;

export namespace ComHubspotSalesModelsViews {
  export type SortOrder = 'ASC' | 'DESC' | unhandledEnumCase;
}

export type GetViewRequestType = Requestify<GetViewRequest>;
export type GetViewResponseType = ViewWithUserRole;
export type GetViewErrorType = ViewsRpcError & HubspotMetadata;
export const getViewRpc: ChirpAvroRpcDetails<
  GetViewRequestType,
  GetViewResponseType,
  GetViewErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'getView',
  auth: 'app',
  fingerprint: 'zJ7XltIO2bz26NRR3RvxW68QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetViewsByComposableSearchRequestType =
  Requestify<ComposableSearchRequest>;
export type GetViewsByComposableSearchResponseType = ComposableSearchResponse;
export type GetViewsByComposableSearchErrorType = ViewsRpcError &
  HubspotMetadata;
export const getViewsByComposableSearchRpc: ChirpAvroRpcDetails<
  GetViewsByComposableSearchRequestType,
  GetViewsByComposableSearchResponseType,
  GetViewsByComposableSearchErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'getViewsByComposableSearch',
  auth: 'app',
  fingerprint: 'b6ZSxJeECfMM160dY_HIUq8QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetDeletedViewsRequestType = Requestify<GetDeletedViewsRequest>;
export type GetDeletedViewsResponseType = GetDeletedViewsResponse;
export type GetDeletedViewsErrorType = ViewsRpcError & HubspotMetadata;
export const getDeletedViewsRpc: ChirpAvroRpcDetails<
  GetDeletedViewsRequestType,
  GetDeletedViewsResponseType,
  GetDeletedViewsErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'getDeletedViews',
  auth: 'app',
  fingerprint: 'U-UVhmVa5e9jBtBLRe5Rsa8QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CreateViewRequestType = Requestify<CreateViewRequest>;
export type CreateViewResponseType = ViewWithUserRole;
export type CreateViewErrorType = ViewsRpcError & HubspotMetadata;
export const createViewRpc: ChirpAvroRpcDetails<
  CreateViewRequestType,
  CreateViewResponseType,
  CreateViewErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'createView',
  auth: 'app',
  fingerprint: '2qw3NgL1ABX26NRR3RvxW68QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CreateViewWithVisualizationSettingsAndPermissionsRequestType =
  Requestify<CreateViewWithVisualizationSettingsAndPermissionsRequest>;
export type CreateViewWithVisualizationSettingsAndPermissionsResponseType =
  CreateViewWithVisualizationSettingsAndPermissionsResponse;
export type CreateViewWithVisualizationSettingsAndPermissionsErrorType =
  ViewsRpcError & HubspotMetadata;
export const createViewWithVisualizationSettingsAndPermissionsRpc: ChirpAvroRpcDetails<
  CreateViewWithVisualizationSettingsAndPermissionsRequestType,
  CreateViewWithVisualizationSettingsAndPermissionsResponseType,
  CreateViewWithVisualizationSettingsAndPermissionsErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'createViewWithVisualizationSettingsAndPermissions',
  auth: 'app',
  fingerprint: 'Tab4Y8hVfUfhNQUINNIypK8QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateViewRequestType = Requestify<UpdateViewRequest>;
export type UpdateViewResponseType = ViewWithUserRole;
export type UpdateViewErrorType = ViewsRpcError & HubspotMetadata;
export const updateViewRpc: ChirpAvroRpcDetails<
  UpdateViewRequestType,
  UpdateViewResponseType,
  UpdateViewErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'updateView',
  auth: 'app',
  fingerprint: 'MGnBmBm2_S326NRR3RvxW68QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type UpdateContractSettingsRequestType =
  Requestify<UpdateContractSettingsRequest>;
export type UpdateContractSettingsResponseType = ViewWithUserRole;
export type UpdateContractSettingsErrorType = ViewsRpcError & HubspotMetadata;
export const updateContractSettingsRpc: ChirpAvroRpcDetails<
  UpdateContractSettingsRequestType,
  UpdateContractSettingsResponseType,
  UpdateContractSettingsErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'updateContractSettings',
  auth: 'app',
  fingerprint: 'dj-BCEyMeP326NRR3RvxW68QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type BulkDeleteViewsRequestType = Requestify<BulkDeleteViewsRequest>;
export type BulkDeleteViewsResponseType = BulkDeleteViewsResponse;
export type BulkDeleteViewsErrorType = ViewsRpcError & HubspotMetadata;
export const bulkDeleteViewsRpc: ChirpAvroRpcDetails<
  BulkDeleteViewsRequestType,
  BulkDeleteViewsResponseType,
  BulkDeleteViewsErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'bulkDeleteViews',
  auth: 'app',
  fingerprint: 'zsfMlO5iVTX3I-rQN0cYM68QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type RestoreViewsRequestType = Requestify<RestoreViewsRequest>;
export type RestoreViewsResponseType = RestoreViewsResponse;
export type RestoreViewsErrorType = ViewsRpcError & HubspotMetadata;
export const restoreViewsRpc: ChirpAvroRpcDetails<
  RestoreViewsRequestType,
  RestoreViewsResponseType,
  RestoreViewsErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'restoreViews',
  auth: 'app',
  fingerprint: '4VA7qlWVWVt4AuIkEUN1j68QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type BulkTransferViewOwnershipRequestType =
  Requestify<BulkTransferViewOwnershipRequest>;
export type BulkTransferViewOwnershipResponseType =
  BulkTransferViewOwnershipResponse;
export type BulkTransferViewOwnershipErrorType = ViewsRpcError &
  HubspotMetadata;
export const bulkTransferViewOwnershipRpc: ChirpAvroRpcDetails<
  BulkTransferViewOwnershipRequestType,
  BulkTransferViewOwnershipResponseType,
  BulkTransferViewOwnershipErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'bulkTransferViewOwnership',
  auth: 'app',
  fingerprint: 'VM85m4lPQRuiZ-HDThoh0a8QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type MultiTransferViewOwnershipRequestType =
  Requestify<MultiTransferViewOwnershipRequest>;
export type MultiTransferViewOwnershipResponseType =
  MultiTransferViewOwnershipResponse;
export type MultiTransferViewOwnershipErrorType = ViewsRpcError &
  HubspotMetadata;
export const multiTransferViewOwnershipRpc: ChirpAvroRpcDetails<
  MultiTransferViewOwnershipRequestType,
  MultiTransferViewOwnershipResponseType,
  MultiTransferViewOwnershipErrorType,
  false
> = {
  serviceName: 'com.hubspot.sales.rpc.ViewsCrudRpc',
  rpcName: 'multiTransferViewOwnership',
  auth: 'app',
  fingerprint: 'sSE5qVh_ta84z16uA-h-oa8QWJB5zcuN',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
